var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkInCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#24CE21",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24L23 26L27 22M15 24C15 25.1819 15.2328 26.3522 15.6851 27.4442C16.1374 28.5361 16.8003 29.5282 17.636 30.364C18.4718 31.1997 19.4639 31.8626 20.5558 32.3149C21.6478 32.7672 22.8181 33 24 33C25.1819 33 26.3522 32.7672 27.4442 32.3149C28.5361 31.8626 29.5282 31.1997 30.364 30.364C31.1997 29.5282 31.8626 28.5361 32.3149 27.4442C32.7672 26.3522 33 25.1819 33 24C33 22.8181 32.7672 21.6478 32.3149 20.5558C31.8626 19.4639 31.1997 18.4718 30.364 17.636C29.5282 16.8003 28.5361 16.1374 27.4442 15.6851C26.3522 15.2328 25.1819 15 24 15C22.8181 15 21.6478 15.2328 20.5558 15.6851C19.4639 16.1374 18.4718 16.8003 17.636 17.636C16.8003 18.4718 16.1374 19.4639 15.6851 20.5558C15.2328 21.6478 15 22.8181 15 24Z",
    stroke: "#24CE21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkInCircle);
export default __webpack_public_path__ + "static/media/Checkmark_in_circle.5eba5a5f8e14ca1366d9b857962a7850.svg";
export { ForwardRef as ReactComponent };